import { Injectable } from '@angular/core'
import {
    HttpInterceptor,
    HttpRequest,
    HttpResponse,
    HttpHandler,
    HttpEvent,
} from '@angular/common/http'
import { Observable } from 'rxjs'
import { tap, finalize } from 'rxjs/operators'

@Injectable()
export class HttpConfigInterceptor implements HttpInterceptor {
    err!: Error
    count = 0

    constructor() {}

    intercept(
        request: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        this.count++

        if (!request.headers.has('Content-Type')) {
            request = request.clone({
                headers: request.headers.set(
                    'Content-Type',
                    'application/json'
                ),
            })
        }

        request = request.clone({
            headers: request.headers.set('Accept', 'application/json'),
        })

        return next.handle(request).pipe(
            tap((event: HttpEvent<any>) => {
                if (event instanceof HttpResponse) {
                    console.log('event--->>>', event)
                }
            }),
            finalize(() => {
                this.count--
            })
        )
    }
}
